import { css } from "styled-components";
var getColumnAsymetricDividedStyles = function getColumnAsymetricDividedStyles(numberOfColumns, isReversed, isAsymmetricDivided) {
  if (numberOfColumns === 2 && isAsymmetricDivided) {
    if (isReversed) {
      return css(["grid-template-columns:1fr 2fr;"]);
    }
    return css(["grid-template-columns:2fr 1fr;"]);
  }
  return null;
};
export default getColumnAsymetricDividedStyles;